module.exports = __webpack_public_path__ + "img/ok_hand.b55d7d46.png";